// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"28":"ce12fe26a52e24c0ef06","57":"70cd82813f81451c9806","559":"96814297ed93cafed54e","614":"faa1442ca84efdaf9d2e"}[chunkId] + "/css/" + {"28":"ShiftPage","57":"index","559":"AgencyWorkers","614":"Approve"}[chunkId] + ".css";
};